import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  vi: {
    // Header
    nav_about: "Về Chúng Tôi",
    nav_menu: "Thực Đơn",
    nav_press: "Báo Chí",
    nav_activities: "Hoạt Động",
    nav_art: "Nghệ Thuật",
    nav_contact: "Liên Hệ",

    // Hero Slider
    hero_booking: "Đặt bàn",
    hero_subtext: "Nhà hàng farm-to-table nấm tươi đầu tiên tại Việt Nam.",

    // About Page
    about_title: "Về chúng tôi",
    about_sidebar_restaurant: "Nhà hàng",
    about_sidebar_farm: "Farm",
    about_sidebar_cuisine: "ẨM THỰC",
    about_sidebar_art: "NGHỆ THUẬT",
    about_p1: "MUFA là một nhà hàng farm-to-table về nấm tươi đầu tiên của Việt Nam, nơi ẩm thực được xây dựng từ mối quan hệ trực tiếp với tự nhiên.",
    about_p2: "Chúng tôi lựa chọn nấm làm trung tâm, không chỉ như một nguyên liệu, mà như một cách tiếp cận: phát triển tự nhiên, thích nghi với môi trường, và giữ trọn hương vị nguyên bản.",
    about_p3: "Từ đó, triết lý ẩm thực được hình thành: tôn trọng nguyên liệu, kết hợp những điều quen thuộc một cách sáng tạo và tiết chế, để hương vị tự dẫn dắt trải nghiệm.",
    about_p4: "Mỗi món ăn là một phần của hành trình, nơi bạn cảm nhận rõ hơn về nguyên liệu, về mùa, và về sự kết nối tự nhiên giữa chúng.",
    about_p5: "Làm việc cùng nguyên liệu địa phương, MUFA giữ lại tinh thần và ký ức vùng miền, đồng thời đặt chúng trong một góc nhìn mới, vừa thân thuộc nhưng vẫn mang sự khác biệt và độc đáo.",

    // Footer
    footer_title: "Thông tin liên hệ",
    footer_address: "Số 10 Võ Nguyên Giáp, khu 1, Tam Đảo, Phú Thọ, Việt Nam",
    footer_hours_title: "Khung giờ mở cửa Mufa:",
    footer_hours_detail: "Sáng từ 8h-14h, Chiều từ 16h-23h",
    footer_email_label: "Email:",
    footer_phone_label: "Điện thoại:",
    footer_map_alt: "Bản đồ chỉ đường đến MUFA Restaurant",

    // Floating Contact
    floating_chat_label: "Chat Messenger",
  },
  en: {
    // Header
    nav_about: "About Us",
    nav_menu: "Menu",
    nav_press: "Press",
    nav_activities: "Activities",
    nav_art: "Art",
    nav_contact: "Contact Us",

    // Hero Slider
    hero_booking: "Book a Table",
    hero_subtext: "Vietnam's first fresh mushroom farm-to-table restaurant.",

    // About Page
    about_title: "About Us",
    about_sidebar_restaurant: "Restaurant",
    about_sidebar_farm: "Farm",
    about_sidebar_cuisine: "CUISINE",
    about_sidebar_art: "ART",
    about_p1: "MUFA is Vietnam's first fresh mushroom farm-to-table restaurant, where cuisine is built upon a direct relationship with nature.",
    about_p2: "We choose mushrooms as our centerpiece, not just as an ingredient, but as an approach: growing naturally, adapting to the environment, and preserving authentic original flavors.",
    about_p3: "From there, our culinary philosophy was formed: respecting ingredients, thoughtfully and creatively combining familiar elements, allowing flavors to naturally guide the experience.",
    about_p4: "Each dish is part of a journey where you gain a deeper appreciation for ingredients, seasons, and the natural connections between them.",
    about_p5: "Working with local ingredients, MUFA preserves regional heritage and spirit while placing them in a fresh perspective—both familiar yet uniquely distinctive.",

    // Footer
    footer_title: "Contact Information",
    footer_address: "No. 10 Vo Nguyen Giap, Zone 1, Tam Dao, Phu Tho, Vietnam",
    footer_hours_title: "Mufa Opening Hours:",
    footer_hours_detail: "Morning: 8:00 AM - 2:00 PM, Evening: 4:00 PM - 11:00 PM",
    footer_email_label: "Email:",
    footer_phone_label: "Phone:",
    footer_map_alt: "Directions map to MUFA Restaurant",

    // Floating Contact
    floating_chat_label: "Chat Messenger",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem('mufa_lang');
    return saved === 'en' ? 'en' : 'vi';
  });

  const setLang = (newLang) => {
    setLangState(newLang);
    localStorage.setItem('mufa_lang', newLang);
  };

  const toggleLang = () => {
    setLang(lang === 'vi' ? 'en' : 'vi');
  };

  const t = (key) => {
    return translations[lang]?.[key] || translations['vi']?.[key] || key;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
